export const standardOnboardingMaxStepCount = 3
export const extendedOnboardingMaxStepCount = 5
